var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.array),function(item){return _c('li',{key:item.id,staticClass:"tab-btn",class:{ active: _vm.selectId === item.id },on:{"click":function($event){return _vm.select(item.id)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }